// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4"};